import { useState } from 'react';

/**
 * Server error state (design_handoff §1g #3): names the failed RPC, gives a
 * copyable support reference, and is explicit that nothing was changed — as
 * opposed to the partial/unknown-outcome state used for failed mutations
 * (design_handoff §1g #6), which makes no such promise.
 */
export function ErrorState({
  title = 'Inventory could not be loaded',
  rpcName,
  onRetry,
}: {
  title?: string;
  rpcName: string;
  onRetry: () => void;
}) {
  const [correlationId] = useState(() => crypto.randomUUID());
  const [timestamp] = useState(() => new Date().toISOString());

  function copyReference(): void {
    void navigator.clipboard.writeText(`${rpcName} · request-id ${correlationId} · ${timestamp}`);
  }

  return (
    <div className="error-state" role="alert">
      <strong>{title}</strong>
      <p>Nothing was changed.</p>
      <p className="mono error-reference">
        {rpcName} · request-id {correlationId} · {timestamp}
      </p>
      <div className="error-actions">
        <button type="button" onClick={onRetry}>
          Retry
        </button>
        <button type="button" onClick={copyReference}>
          Copy reference
        </button>
      </div>
    </div>
  );
}
